(function Module() {
    'use strict';
    mySynch.controller('BodyScoringV2_0Controller', [
        '$scope',
        '$interval',
        'ApiFactory',
        'F360Service',
        'F360Constant',
        '$window',
        'AuditService',
        '$location',
        'CookieFactory',
        'MySynchFactory',
        'performanceMetricsService',
        'performanceContextService',
        '$q',
        'clientLoggerService',
        function BodyScoringV2_0Controller($s, $interval, api, f360Service, f360Constant, $window, auditService, $location, cookies,MSF, perfMetricSvc, perfContextSvc, $q, log) {
            var self = this;
           
            $s.performanceContext = null;

            $s.breadcrumbs = f360Service.getReport360Breadcrumbs();
            $s.lastBreadcrumbs = $s.breadcrumbs.pop();
            $s.heading = $s.lastBreadcrumbs.heading;

            $s.auditId = auditService.getAuditId($location.url());
            $s.auditAnswers = [];

            $s.avgQuestion = {};
            $s.avgAnswer = {};

            $s.numberCows = 0;
            $s.scores = [];
            $s.avgScore = 0;
            $s.maxScore = 0;
            $s.minScore = 0;
            $s.stepScore = 0.25;

            $s.currentIndex = 0;
            $s.currentScore = 0;
            $s.allowComplete = false;
            $s.scoreLoaded = false;
            $s.maxAllowedScore = 5;

            $s.showPrevious = false;
            $s.showNext = true;
            $s.showAdd = true;
            $s.allowLeaveThisPage = false;
            $s.isScoreComplete = false;

            $s.sliderWidth = 300;

            $s.mySynchState = {};
            $s.activeFarm = {};
            $s.currentHerd = {};

            $s.auditApiVersion;

            $s.codeFile = [];

          
            // flag for that is set true when and update answers call occurs successfuly without updating the server
            $s.syncInProgress = false;
            $s.isDirty = false;
            $s.updateInProgress = false;

            $s.checkSyncStatusTimer = undefined;

            // watcher degresigration variables
            var deregOnFarmChange = undefined;

            function loadCurrentHerd() {
                const loadCurrentHerdPromise = $q.defer();
                auditService.getHerdsByFarmId(_.get($s.activeFarm, 'farmId'), function getF360HerdsByFarmId(err, herd) {
                    if (err) {
                        console.log('err', err);
                        loadCurrentHerdPromise.resolve();
                    } else {
                        $s.currentHerd = herd[0];
                        var currentHMS = _.get($s.currentHerd, 'herdMgmtSoftware');
                        //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here

                        if (_.isNull(currentHMS) || _.isUndefined(currentHMS)) {
                            loadCurrentHerdPromise.resolve();
                            MSF.loadPage('Login');
                        }else{
                            loadCurrentHerdPromise.resolve();
                        }
                    }
                });
                return loadCurrentHerdPromise.promise;
            }

            function checkPermissions() {
                const checkPermissionsPromise = $q.defer();
                // we need to check to see if the user who is viewing this screen is the person who create the audit
                // otherwise we need to redirect them to the top level f360 report
                auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
                    var currentAudit = _.find(data,{AuditId: $s.auditId},'Name');

					var checkedOutToPersonId = _.get(MSF.parseJsonStringToObject(_.get(currentAudit,'CheckedOutTo','{}'),"Failed to parse CheckedOutTo in checkPermissions on Body Scoring."), 'PersonId');
					 // if checkedOutToPersonId is undefined then the audit is not checked out and we need to redirect the user to the top level f360 report
					 // Similarly if the audit is checked out to a different user than the current logged in one, we need to redirect the user to the top level f360 report
					if(_.isUndefined(checkedOutToPersonId) || (!_.isEqual(checkedOutToPersonId,_.get(cookies.user,'PersonId')))){
                        checkPermissionsPromise.resolve();
						MSF.loadPage('Fertility360report');
					}else{
                        checkPermissionsPromise.resolve();
                    }
                });
                return checkPermissionsPromise.promise;
            }

            function getLocalStorageKey(subKey) {
                return $s.auditId + '_' + auditService.getSubHeading($s.heading) + $s.avgQuestion.QuestionId + subKey;
            }

            $s.loadReportData = function loadReportData() {
                const loadReportDataPromise = $q.defer();

                perfMetricSvc.startTiming("Page:F360BodyScoringGetIndexedDbAnswerList:Request");
                auditService.getIndexedDBAnswerList($s.auditId, $s.performanceContext, function getIndexedDBAnswerList(err, data) {
                    perfMetricSvc.endTiming("page","Page:F360BodyScoringGetIndexedDbAnswerList:Request", $s.performanceContext);
                    perfMetricSvc.startTiming("Page:F360BodyScoring:Build");
                    if (err) {
                        console.log('error getting F360 Answer List: ' + err);
                        MSF.confirmation.danger(err, false);
                    }

                    if (data && data.length) {
                        try {
                            $s.auditAnswers = JSON.parse(data);
                        } catch (e) {
                            log.error("failed to parse answer list json : " + _.get(e, 'message', " "));
                        }
                    } else {
                        $s.auditAnswers = [];
                    }

                    perfMetricSvc.startTiming("Page:F360BodyScoringGetIndexedDBQuestionList:Request");
                    auditService.getIndexedDBQuestionList($s.auditId, $s.performanceContext, function getIndexedDBQuestionList(err, data) {
                        perfMetricSvc.endTiming("page","Page:F360BodyScoringGetIndexedDBQuestionList:Request", $s.performanceContext);
                        if (err) {
                            console.log('error getting F360 Question List: ' + err);
                            MSF.confirmation.danger(err, false);
                        }

                        if (data && data.length) {
                            var parseDataQuestion = JSON.parse(data);
                            var questionDetailsJson = parseDataQuestion.QuestionsJson;

                            for (let i = 0; i < questionDetailsJson.length; i++) {
                                var question = questionDetailsJson[i].QuestionJson[0];
                                var questionSubHeading = auditService.getSubHeading(question.SubHeading);

                                if (questionSubHeading == auditService.getSubHeading($s.heading)) {
                                    if (auditService.checkAverageQuesitonBCS(question)) {
                                        $s.avgQuestion = question;
                                        $s.avgAnswer = $s.loadAnswerData(question.QuestionId);
                                        $s.questionAvgScore = question.QuestionId;
                                    }
                                }
                            }

                          
                            $s.calculateScore();
                            
                            $s.scoreLoaded = true;
                            loadReportDataPromise.resolve();
                            $s.$apply();
                            perfMetricSvc.endTiming("page","Page:F360BodyScoring:Build", $s.performanceContext);
                        } else {
                            console.log("data was null or empty.");
                            loadReportDataPromise.resolve();
                            perfMetricSvc.endTiming("page","Page:F360BodyScoring:Build", $s.performanceContext);
                        }
                    });
                });
            };

            $s.loadAnswerData = function (quesionId) {
                for (let i = 0; i < $s.auditAnswers.length; i++) {
                    if (quesionId == $s.auditAnswers[i].QuestionId) {
                        return $s.auditAnswers[i].AnswerDetailsJson;
                    }
                }

                return undefined;
            };

            $s.hasScoreACow = function hasScoreACow(){
                return $s.scores.length > 0 && _.some($s.scores,function(score){return Number(score) > 0;});
            }

            $s.stayOnPage = function stayOnPage() {
                var modalDelete = document.getElementById("popupModal");
                modalDelete.style.display = "none";
            };

            $s.leaveThisPage = function leaveThisPage() {
                $s.allowLeaveThisPage = true;
                window.location.href = $s.nextPage;
            };

            $s.$on('$locationChangeStart', confirmLeavePage);

            function confirmLeavePage(event, next, current) {
                if (next.includes($s.breadcrumbs[2].url)) {
                    var sectionKey = `{"subHeading": "${$s.heading}", "questionId": "${$s.questionAvgScore}"}`;
                    localStorage.setItem(f360Constant.keySectionScroll, sectionKey);
                } else {
                    localStorage.removeItem(f360Constant.keySectionScroll);
                }

                if (!$s.isScoreComplete && !$s.allowLeaveThisPage ) {
                    event.preventDefault();
                    $s.nextPage = next;
                    var modalDelete = document.getElementById("popupModal");
                    modalDelete.style.display = "block";
                }
            }

            $s.scoreComplete = function scoreComplete(link) {
                $s.isScoreComplete = true;
                $s.updateInProgress = true;
                log.info("BSC scoreComplete start");
                //localStorage.setItem(getLocalStorageKey('_bcs_'), $s.scores);
                var notes = null;

                if (typeof $s.avgAnswer !== 'undefined' && typeof $s.avgAnswer.Notes !== 'undefined') {
                    notes = $s.avgAnswer.Notes;
                }

                var detailValidation = $s.avgQuestion.QuestionDetailsJson.industryGuideline;
                var metGuidelines = true;

                if (detailValidation && detailValidation.validationTemplates) {
                    metGuidelines = $s.validateTemplate(detailValidation.validationTemplates, Number($s.avgScore), $s.avgQuestion);
                } else if (detailValidation && detailValidation.compare) {
                    metGuidelines = $s.validateCompare(detailValidation.compare, Number($s.avgScore), $s.avgQuestion);
                }

                var obAnswer = "";
                try {
                    var answerTemplateDetailsJsonArray = _.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ANSWER"}),'detailsJson');
					
					  obAnswer =  _.get(JSON.parse(answerTemplateDetailsJsonArray),'[0].template');// _.get(answerTemplateDetailsJsonArray,'[0].template');
                    // set original default values that differ than how its defined in sql , but  might not actually need to be these values
                    _.set(obAnswer, 'QuestionId', $s.avgQuestion.QuestionId);
                    _.set(obAnswer, 'QuestionKey',$s.avgQuestion.QuestionKey);
                    _.set(obAnswer, 'AnswerDetailsJson.Answered', true);
                    _.set(obAnswer, 'AnswerDetailsJson.Value', $s.avgScore);
                    _.set(obAnswer, 'AnswerDetailsJson.MetGuideline', metGuidelines);
                    _.set(obAnswer, 'AnswerDetailsJson.NoGuideInvolved', true);
                    _.set(obAnswer, 'AnswerDetailsJson.Notes', notes);
                    _.set(obAnswer, 'AnswerDetailsJson.FormattedRecommends', undefined);
                    _.set(obAnswer, 'AnswerDetailsJson.TargetDate', null);
                    _.set(obAnswer, 'AnswerDetailsJson.Status', null);
                } catch (e) {
                    log.info("Section Page: Answer Template failed to be acquired from Code File or failed to be parsed");
                }

                var foundIndex = $s.auditAnswers.findIndex(item => item.QuestionId == $s.avgQuestion.QuestionId);
                if (foundIndex > -1 && $s.auditAnswers.length > 0) {
                    $s.auditAnswers.splice(foundIndex, 1);
                }

                if(!_.isEqual(obAnswer,"")){
                    $s.auditAnswers.push(obAnswer);
                }
                  

                // save data
                var AnswerDetailsJson = JSON.stringify($s.auditAnswers);

                $s.isDirty = true;
                auditService.updateAnswer($s.auditId, AnswerDetailsJson, function getF360Update(err, data) {
                    if (err) {
                        log.error('error getting F360 online check: ' + err);
                        $s.isDirty = false;
                        $s.updateInProgress = false;
                        log.info("BSC scoreComplete: error in updating answer, end update");
                    } else {
                        // if the update was successfull and we are online we can then the data was synced and we can set isDirty false
                        if (window.navigator.onLine) {
                            $s.isDirty = false;

                            auditService.updateIsDirty($s.auditId, $s.isDirty, function getIsDirtyUpdate(err, data) {
                                if (err) {
                                    log.error('error updateing isDirty flag: ' + err);
                                }

                                auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
                                    var auditlistItem = _.find(data, { AuditId: $s.auditId });

                                    //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
                                    if (!_.isUndefined(auditlistItem)) {
                                        auditService.updateLastSyncedDate($s.auditId, _.get(auditlistItem, 'SyncedOn'), function getUpdateLastSyncDateData(err, data) {
                                            if (err) {
                                                log.error('error updating server with device data: ' + err);
                                            }
                                            $s.updateInProgress = false;

                                            log.info("BSC scoreComplete: udpated audit sync date after answer update, update end");
                                            $window.location.href = link;
                                        });
                                    } else {
                                        log.info("could not find audit indexedDB failed to update BSC , update end");
                                        $s.updateInProgress = false;
                                    }
                                });
                            });
                        } else {
                            auditService.updateIsDirty($s.auditId, $s.isDirty, function getIsDirtyUpdate(err, data) {
                                if (err) {
                                    log.error('error updateing isDirty flag: ' + err);
                                }
                                $s.updateInProgress = false;
                                log.info("BSC scoreComplete offline , but updated IsDirty Flag , update end");
                                $window.location.href = link;
                            });
                        }
                    }
                });

            };

            window.scrollTo(0, 0);
            $s.disabledBtn = true;

            $s.calculateScore = function () {
                $s.scores = _.filter($s.scores, function (score) { return score > 0; });
                if ($s.scores.length > 0) {
                    var sumValue = 0;
                    for(let i = 0; i < $s.scores.length; i++) {
                        if($s.scores[i] > 0) {
                            $s.scores[i] = Number($s.scores[i]);
                            sumValue += Number($s.scores[i]);
                        }
                    }

                    $s.avgScore = (sumValue / $s.scores.length).toFixed(2);
                    $s.minScore = Math.min(...$s.scores);
                    $s.maxScore = Math.max(...$s.scores);
                }else{
                    $s.avgScore = 0;
                    $s.minScore = 0;
                    $s.maxScore = 0;
                }
                
            };

            $s.addCow = function addCow() {
                if (typeof $s.scores[$s.currentIndex] !== 'number' || $s.scores[$s.currentIndex] <= 0) {
                    return;
                }

                $s.currentIndex += 1;
                var nextScore = 0;               

                $s.showCowScore(nextScore);
            };

            $s.showCowScore = function (score) {

                var slider = document.getElementById('myinput');
                var positionPercentage = score / $s.maxAllowedScore * 100;
                slider.value = positionPercentage;
                document.getElementById("myinput").style.background = 'linear-gradient(to right, #0C547E 0%, #0C547E ' + positionPercentage + '%, #96b6d6 ' + positionPercentage + '%, #96b6d6 100%)';
                getlocationSliderText(score);
            };

            function getlocationSliderText(score) {
                var locationText = score / $s.maxAllowedScore * $s.sliderWidth;
                if (locationText == 0) {
                    locationText = f360Constant.locationMinium;
                } else if (locationText > 120 && locationText < 290) {
                    locationText = locationText - f360Constant.numberMedML;
                }
                else if (locationText > 290) {
                    locationText = locationText - f360Constant.numberMaxML;
                }

                var valueText = document.getElementById("valueCount");
                valueText.innerHTML = score === 0 ? "&nbsp" : score;
                valueText.style.marginLeft = locationText + 'px';
            }

            $s.scoreCow = function (score) {
                if (score > 0) {
                    $s.scores[$s.currentIndex] = score;
                } else {
                    $s.scores = _.slice($s.scores,0,$s.currentIndex);
                }
                $s.calculateScore();

                if (!$s.$$phase) {
                    $s.$digest();
                }
            };

            // TODO: move this function into a service or some kind of global place
            $s.validateTemplate = function validateTemplate(valTpl, value, questionDetails) {
                var validationResult = true;
                if (valTpl !== undefined) {
                    var detailValidationTpl = valTpl[0];

                    if (detailValidationTpl.MINVALUE !== undefined) {
                        validationResult = value >= detailValidationTpl.MINVALUE;
                    }

                    if (validationResult && detailValidationTpl.MAXVALUE !== undefined) {
                        validationResult = value <= detailValidationTpl.MAXVALUE;
                    }

                    if (validationResult && detailValidationTpl.WITHINRANGE !== undefined) {
                        validationResult = value >= detailValidationTpl.WITHINRANGE.loValue && value <= detailValidationTpl.WITHINRANGE.hiValue;
                    }

                    if (validationResult && detailValidationTpl.NOTWITHINRANGE !== undefined) {
                        validationResult = value < detailValidationTpl.WITHINRANGE.loValue && value > detailValidationTpl.WITHINRANGE.hiValue;
                    }

                    if (validationResult && detailValidationTpl.WITHINLIST !== undefined) {
                        validationResult = value in detailValidationTpl.WITHINLIST;
                    }

                    if (detailValidationTpl.NOTWITHINLIST !== undefined) {
                        validationResult = !(value in detailValidationTpl.NOTWITHINLIST);
                    }
                }

                return validationResult;
            };
            // TODO: move this function into a service or some kind of global place
            $s.validateCompare = function validateCompare(valCop, value, questionDetails) {
                var validationResult = true;
                if (valCop !== undefined) {
                    var detailCompare = valCop;
                    var number1 = detailCompare.numValue1;
                    var number2 = detailCompare.numValue2;

                    if (detailCompare.operation) {
                        switch (detailCompare.operation) {
                            case "NE":
                                validationResult = value !== number1;
                                break;
                            case "GT":
                                validationResult = value > number1;
                                break;
                            case "GE":
                                validationResult = value >= number1;
                                break;
                            case "LE":
                                validationResult = value <= number1;
                                break;
                            case "LT":
                                validationResult = value < number1;
                                break;
                            case "EQ":
                                validationResult = value === number1;
                                break;
                            case "BE":
                                validationResult = (value >= number1 && value <= number2);
                                break;
                            case "IN":
                                validationResult = (value in number1);
                                break;
                            case "NI":
                                validationResult = !(value in number1);
                                break;
                            default:
                                break;
                        }
                    }
                }

                return validationResult;
            };
            document.getElementById("myinput").oninput = function () {
                var score = this.value * $s.maxAllowedScore / 100;
                $s.scoreCow(score);
                var positionPercentage = this.value;
                this.style.background = 'linear-gradient(to right, #0C547E 0%, #0C547E ' + positionPercentage + '%, #96b6d6 ' + positionPercentage + '%, #96b6d6 100%)';
                getlocationSliderText(score);
            };

            function loadReport(){
                return $q((resolve, reject) => {
                    $q.all([
                        loadCurrentHerd(),
                        checkPermissions(),
                        $s.loadReportData()
                    ]).then(() => {
                        console.log('All promises resolved');
                        resolve();
                    })
                });
            }

            $s.$on("$destroy", function () {
                deregOnFarmChange();
                $s.performanceContext = null;
            });

            deregOnFarmChange = $s.$on('farm:changed', function () {
                MSF.loadPage('Fertility360report');
            });

            MSF.ready(function onMsfReady() {
                $s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId'));
                $s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
                //local storage data 	
                var mySynchStateJSON = localStorage.getItem('MySynch-state');
                if (!_.isUndefined(mySynchStateJSON)) {
                    $s.mySynchState = JSON.parse(mySynchStateJSON);

                    $s.activeFarm = _.get($s.mySynchState, 'value.activeFarm', {});
                }

                $s.sliderWidth = $("#myinput").width();

                auditService.getActiveOrCurrentAuditVersion($s.performanceContext).then(function (apiVersion) {
                    $s.auditApiVersion = apiVersion;
                });

                // loadCurrentHerd();
                // checkPermissions();
                // $s.loadReportData();
                
                perfMetricSvc.startTiming("Page:F360BodyScoring:Render");
				loadReport().then(() => {
					perfMetricSvc.markPageReady("Page:F360BodyScoring:Render", $s.performanceContext);
				});
            });

        }
    ]);
})();
